// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_gridmode_wrap {
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/app/components/profile-aggrid-view/profile-aggrid-view.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ","sourcesContent":[".card_gridmode_wrap {\n    height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
